import { StateServices } from './../../../../services/state.services';
import { RestServices } from './../../../../services/rest.services';
import { DatepickerHelper } from './../../../../../helper/datepicker.helper';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { SharedServices } from '@services/shared.services';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '@services/auth.services';
import { Component, OnInit } from '@angular/core';
import * as moment from 'moment'
import { onsNotification } from 'ngx-onsenui'
import * as _html2canvas from "html2canvas";
import { PATTERNS, SETTING_KEYS } from '@app/shared/constants/system.const'

@Component({
    selector: 'app-receipt',
    templateUrl: './receipt.component.html',
    styleUrls: ['./receipt.component.css'],
})
export class ReceiptComponent implements OnInit {
    readonly PATTERNS = PATTERNS
    readonly SETTING_KEYS = SETTING_KEYS
    en = {}
    showEN = true

    formNewClient: FormGroup
    html2canvas: any = _html2canvas;

    //day
    showDateBirthday: any = 'Click to Select'
    showDateStart: any = moment().format('YYYY.MM.DD ddd').valueOf
    showDateLast: any = 'Click to Select'
    showDateAccountStart: any = 'Click to Select'
    loadingCheck = false
    timestampBirthday: number
    timestampStart: number
    timestampLast: number
    timestampAccountDate: number
    showAge: number = 0
    dateBirthday: any
    dateStart: any
    dateLast: any
    dateAccountStart: any
    optionsStartDate: any = { viewMode: 'days', ...DatepickerHelper.BASE_OPTIONS }

    listCommon: any = {};
    listPdf: any = [];

    idClient: any;
    clientIdParam: any = '';

    enableBehavior = 'false'

    clientInfo: any = {}
    headerName: any = '';
    isFamilyName: any = ''

    dataPdf: any = {};

    var_checkText?: any = "";
    var_checkQuantityText?: any = 0;

    obj_checkQuantityText?: any = {};
    validatePrice: boolean = true;
    validateTaxRateMoney: boolean = true;

    isDownloadingPdf: boolean = false
    btnDownloadIndex: number = -1

    htmlPDF: any = '';

    constructor(
        private authData: AuthService,
        private _sharedService: SharedServices,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private restApi: RestServices,
        private router: Router,
        private stateServices: StateServices,
    ) { }

    ngOnInit() {
        this.route.parent.paramMap.subscribe((params: ParamMap) => {
            const id = params.get('id')
            this.idClient = id
            this.clientIdParam = '{"clientId":"' + [this.idClient] + '"}'
        })

        this.showDateStart = moment().format('YYYY.MM.DD ddd').valueOf()
        this.formNewClient = this.formBuilder.group({
            zipCode: '',
            businessName: '',
            taxRate: '',
            total: '',
            price: '',
            priceText: '',
            numberReceipt: '',
            moneyOrder: '',
            transferMoney: '',
            other: '',
            rules: '',
            taxRateMoney: '',
            startDate: moment(),
            urls: this.formBuilder.array([this.createItemUrl()]),

        })
        this.getCommon();
    }


    checkRedirect(routesLink) {
        let routeLinkChange = routesLink
        let redirectUrl = './app/main/client/edit/' + this.idClient + '/'
        routeLinkChange = redirectUrl + routesLink
        const arr = ['Receipt', routesLink]
        this.router.navigate([routeLinkChange]);
        this._sharedService.emitChange(arr)
    }

    checkLanguage() {
        if (localStorage.getItem('lang') == 'true') {
            this.checkRedirect('home');
        }
        if (localStorage.getItem('lang') == 'false') return true

    }

    getCommon() {
        const resourceUrl = 'resource'

        const clientIdReceipt = {};
        const result = '{"clientId":"' + this.idClient + '"}'
        clientIdReceipt[result] = true
        const clientId = {}
        clientId[this.idClient] = true
        const resourceData = {
            actions: [], status: {
                client: {
                    map: clientId,
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        alignerMail: true, common: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                }, clientReceipt: {
                    paths: clientIdReceipt,
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const commonSetting = success['response']['setting']['map']['common']
                const listPdf = success['response']['clientReceipt']['paths'][result];
                const clientInfo = success['response']['client']['map'][this.idClient];
                const fullName = clientInfo.familyName + ' ' + clientInfo.firstName  
                const billName = clientInfo.billName
                this.headerName = billName ? billName + ' 様' : fullName + ' 様'
                listPdf.sort(function (a, b) { return b.time - a.time });
                listPdf.forEach(ele => {
                    ele.createTime = moment(ele.createTime).format("YYYY/MM/DD");
                    ele.time = moment(ele.time).format("YYYY/MM/DD");
                    ele.updateTime = moment(ele.updateTime).format("YYYY/MM/DD HH:mm");
                    });
                this.listCommon = commonSetting
                    this.listPdf = listPdf;
                this.clientInfo = clientInfo
                if (this.listCommon.taxRate == '' || this.listCommon.taxRate == undefined || this.listCommon.taxRate == null || this.listCommon.taxRate == 0) {
                        this.listCommon['taxRateMoney'] = null;
                    this.formNewClient.patchValue(
                        {
                            'zipCode': this.listCommon.zipCode,
                            'businessName': this.listCommon.businessName,
                            'taxRate': this.listCommon.taxRate,
                            'taxRateMoney': this.listCommon.taxRateMoney
                        }
                    );
                    }
                if (this.listCommon.taxRate != '' || this.listCommon.taxRate != undefined || this.listCommon.taxRate != null || this.listCommon.taxRate != 0) {
                    this.formNewClient.patchValue(
                        {
                            'zipCode': this.listCommon.zipCode,
                            'businessName': this.listCommon.businessName,
                            'taxRate': this.listCommon.taxRate,
                        }
                    );
                    }
                if(commonSetting.chooseTheme == "black") this.setButtonColor(commonSetting.chooseTheme);

            })
        })
    }

    //check theme black set button
    setButtonColor(chooseTheme){
        let button = document.getElementById("button-color");
        // button.classList.add("button-white");
        button.classList.remove("input-label");
    }

    //convert e to number
    convert(n?: any) {
        if (!n) return
        var sign = +n < 0 ? "-" : "",
            toStr = n.toString();
        if (!/e/i.test(toStr)) {
            return n;
        }
        var [lead, decimal, pow] = n.toString()
            .replace(/^-/, "")
            .replace(/^([0-9]+)(e.*)/, "$1.$2")
            .split(/e|\./);
        return +pow < 0 ?
            sign + "0." + "0".repeat(Math.max(Math.abs(pow) - 1 || 0, 0)) + lead + decimal :
            sign + lead + (+pow >= decimal.length ? (decimal + "0".repeat(Math.max(+pow - decimal.length || 0, 0))) : (decimal.slice(0, +pow) + "." + decimal.slice(+pow)))
    }

    updatePrice(ev: any, index: any) {
        const evConverted = this.convert(ev);
        this.checkQuantityText(evConverted, 'price');
        let total;
        let taxRateMoney;
        let taxRate = 0;
        let result = this.PATTERNS.PATTERN_004.test(evConverted)
        if (!result && evConverted) {
            this.obj_checkQuantityText.price = 1000
        }
        if(evConverted.toString().length > 10){
            this.formNewClient.patchValue({
                'taxRateMoney': ''
            });
            return;
        }
        if (!this.formNewClient.get('taxRate').value || this.formNewClient.get('taxRate').value == '') return;
        if (this.formNewClient.get('taxRate').value && this.formNewClient.get('taxRate').value != '') taxRate = Number(this.formNewClient.get('taxRate').value)
        if (evConverted && index == 'price') {
            this.validatePrice = true;
            total = Number(evConverted / ((taxRate / 100) + 1))
            taxRateMoney = evConverted - total
            // total = this.convert(total)
            taxRateMoney = Math.round(taxRateMoney)
            if (!taxRateMoney) taxRateMoney = 0;
            this.checkQuantityText(taxRateMoney, 'total');

            if (!total || total == 0) total = ''
            this.formNewClient.patchValue({
                'total': total,
                'taxRateMoney': taxRateMoney
            });
            return;
        }
        if (!evConverted) {
            this.validatePrice = false;
            this.formNewClient.patchValue({
                'total': '',
                'taxRateMoney': ''
            });
            this.obj_checkQuantityText.price = 0
            return;
        }
    }

    /*region call api create, update*/
    saveReceipt() {
        let dataSave = {
            clientId: this.idClient,
            time: moment(this.formNewClient.get('startDate').value).utc().valueOf(),
            numberReceipt: this.formNewClient.get('numberReceipt').value,
            zipCode: this.formNewClient.get('zipCode').value,
            businessName: this.formNewClient.get('businessName').value,
            taxRate: this.formNewClient.get('taxRate').value,
            taxRateMoney: this.formNewClient.get('taxRateMoney').value,
            total: this.convert(this.formNewClient.get('total').value),
            price: this.convert(this.formNewClient.get('price').value),
            priceText: this.formNewClient.get('priceText').value,
            moneyOrder: this.formNewClient.get('moneyOrder').value,
            transferMoney: this.formNewClient.get('transferMoney').value,
            other: this.formNewClient.get('other').value,
            rules: this.formNewClient.get('rules').value,
            createTime: moment().utc().valueOf(),
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [
                {
                    collection: 'clientReceipt',
                    type: 'create',
                    value: dataSave
                },
            ],
            status: {
                client: {
                    map: { [this.idClient]: true },
                    paths: { '{}': true },
                },
                clientDevice: {
                    paths: { [this.clientIdParam]: true },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    if (success['status'] === 'OK') {
                        this._sharedService.emitChangeParent(success['response']['clientDevice']['paths'][this.clientIdParam])
                    }
                    this.getCommon();
                });
        });
    }

    updateReceipt(item) {
        console.log(item);
        const resourceUrl = 'resource';
        const resourceData = {
            actions: [
                {
                    collection: 'clientReceipt',
                    type: 'update',
                    id: item._id,
                    value: {},
                },
            ],
            status: {},
        };
        this.authData.authToken().then((tokenReNew) => {
            this.restApi
                .http_post(resourceUrl, resourceData, tokenReNew)
                .subscribe((success) => {
                    if (success['status'] === 'OK') {
                        this.getCommon();
                    }
                });
        });
    }

    newReceipt() {
        if (Number(this.obj_checkQuantityText['numberBills']) > 256 || Number(this.obj_checkQuantityText['rules']) > 256) return;
        if (Number(this.obj_checkQuantityText['price']) > 10 ||
            Number(this.obj_checkQuantityText['total']) > 10 ||
            Number(this.obj_checkQuantityText['priceText']) > 10 ||
            Number(this.obj_checkQuantityText['moneyOrder']) > 10 ||
            Number(this.obj_checkQuantityText['transferMoney']) > 10 ||
            Number(this.obj_checkQuantityText['other']) > 10) return;
        let checkVal1 = true;
        let checkVal2 = true;
        if (this.formNewClient.get('price').value == "" || this.formNewClient.get('price').value == null || this.formNewClient.get('price').value == undefined) {
            this.validatePrice = false;
            checkVal1 = false;
        }
        if (this.formNewClient.get('taxRateMoney').value == "" || this.formNewClient.get('taxRateMoney').value == null || this.formNewClient.get('taxRateMoney').value == undefined || !this.formNewClient.get('taxRateMoney').value) {
            this.obj_checkQuantityText['total'] = 0;
            checkVal2 = true;
        }
        if (this.formNewClient.get('taxRateMoney').value == 0) {
            this.obj_checkQuantityText['total'] = 1;
            checkVal2 = true;
        }
        if (!checkVal1 || !checkVal2) return;

        onsNotification.confirm({
            message: this.en['client-detail-profile-confirm-submit-message'],
            title: '<b>' + this.en['client-detail-profile-confirm-submit-title'] + '</b>',
            buttonLabels: [this.en['client-detail-profile-confirm-submit-lable-cancel'], this.en['client-detail-profile-confirm-submit-lable-ok']],
            modifier: 'rowfooter',
            callback: i => {
                if (i === 1) {  // here this is not cancelled.  1 is correct.
                    this.saveReceipt()
                    const profileSave: any = {}
                    profileSave['save'] = true
                    this.stateServices.emitChangeProfileSave(profileSave)
                    this.resetform(this.formNewClient);
                    this.obj_checkQuantityText = {}
                    this.validatePrice = true;
                }
            },
        })

    }
    /*region day*/

    /*region day*/
    nextDate(timestampAdd, day, option) {
        if (option === 'start') {
            if (this.showDateStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'start')
            }
        } else if (option == 'last') {
            if (this.showDateLast !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'last')
            }
        } else {
            if (this.showDateAccountStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'account')
            }
        }
        //this.resetform(this.formNewClient)
    }

    resetform(formNewClient: FormGroup) {
        formNewClient.reset();
        formNewClient.patchValue({
            'taxRate': this.listCommon.taxRate,
            'startDate': moment(),
            ...formNewClient
        });
    }

    checkDatepickerLoading() {
        this.loadingCheck = true
    }

    prevDate(timestampAdd, day, option) {
        if (option === 'start') {
            if (this.showDateStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'start')
            }
        } else if (option === 'last') {
            if (this.showDateLast !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'last')
            }
        } else {
            if (this.showDateAccountStart !== 'Click to Select') {
                let adDate = moment(timestampAdd)
                let timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
                let event = {
                    '_d': timestampDate,
                    '_i': timestampDate,
                }
                this.updateDatepicker(event, 'account')
            }
        }
        //this.resetform(this.formNewClient)
    }

    updateDatepicker(event, option) {
        let offsetTimezone = new Date().getTimezoneOffset()
        let addTime = 24 + (offsetTimezone / 60)
        if (event && event['_d']) {
            if (this.loadingCheck) {
                this._sharedService.emitChange(['activeAlertNewClient', 'profile', this.idClient])
            }
            if (option == 'birthday') {
                const timestamp = moment(event['_d'])
                timestamp.set({ hours: 10 })
                this.timestampBirthday = moment(timestamp).utc().startOf('day').valueOf()
                this.showDateBirthday = moment(timestamp).format('YYYY.MM.DD ddd')
                this.showAge = moment().startOf('day').diff(moment(this.timestampBirthday).add(addTime, 'hours'), 'years')
                this.dateBirthday = moment(timestamp)
            } else if (option == 'start') {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampStart = moment().utc().startOf('day').valueOf()
                    this.showDateStart = moment().format('YYYY.MM.DD ddd')
                    this.dateStart = moment(moment().valueOf())
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampStart = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateStart = moment(timestamp).format('YYYY.MM.DD ddd')
                    this.dateStart = moment(moment(timestamp).valueOf())
                }
            } else if (option == 'last') {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampLast = moment().utc().startOf('day').valueOf()
                    this.showDateLast = moment().format('YYYY.MM.DD ddd')
                    this.dateLast = moment(moment().valueOf())
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampLast = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateLast = moment(timestamp).format('YYYY.MM.DD ddd')
                    this.dateLast = moment(moment(timestamp).valueOf())
                }
            } else {
                let eventProcess = event['_d']
                if (moment(eventProcess).format('YYYY.MM.DD ddd') == moment().format('YYYY.MM.DD ddd')) {
                    this.timestampAccountDate = moment().utc().startOf('day').valueOf()
                    this.showDateAccountStart = moment().format('YYYY.MM.DD ddd')
                    this.dateAccountStart = moment(moment().valueOf())
                } else {
                    const timestamp = moment(event['_d'])
                    timestamp.set({ hours: 10 })
                    this.timestampAccountDate = moment(timestamp).utc().startOf('day').valueOf()
                    this.showDateAccountStart = moment(timestamp).format('YYYY.MM.DD ddd')
                    this.dateAccountStart = moment(moment(timestamp).valueOf())
                }
            }
        }
        //this.resetform(this.formNewClient)


    }
    createItemUrl(urlName = '', url = ''): FormGroup {
        return this.formBuilder.group({
            urlName: urlName,
            url: url,
        })
    }
    /*endregion day*/
    preSubmit() {

    }

    changeLanguage() {
        this.checkLanguage();
        return this.en = this.authData.showLang(this.showEN)
    }

    downloadAsPDF(item: any, index: any) {
        this.updateReceipt(item)
        this.dataPdf = item;
        this.btnDownloadIndex = index
        item.familyName = this.clientInfo.familyName + ' ' + this.clientInfo.firstName + ' 様'
        item.clinicName = this.listCommon.clinicName
        item.city = this.listCommon.city
        item.address = this.listCommon.address
        item.phone = this.listCommon.phone
        setTimeout(()=> {
            let divEmpty = document.getElementById('div-empty-reciept');
            let divEmpty1 = document.getElementById('div-empty-reciept-1');
            let surplus = document.getElementById('div-resize-reciept').offsetWidth - 112;
            let surplus1 = document.getElementById('div-resize-reciept-1').offsetWidth - 112;
            divEmpty.style.width = (120 + surplus).toString() + 'px';
            divEmpty1.style.width = (120 + surplus1).toString() + 'px';

            let datahtml = document.getElementById("pdfTable").innerHTML;
            let fileName = "receipt_" + this.idClient.toString()+ '.' + index.toString() + "_" + moment().format('YYYYMMDDHHmmss')
            this.printHtml(datahtml,fileName)
        }, 0)
    }

    formatDateJapan(value: any) {
        if (value) {
            let input = value.toString().split('/');
            let output = input[0].toString() + '年' + input[1].toString() + '月' + input[2].toString() + '日';
            return output
        }
        else return 'undefine';
    }

    checkQuantityText(ev: any, type: any) {
        let result
        // if(!ev &&  type == "total" && this.formNewClient.get('taxRate').value != "" && this.formNewClient.get('taxRate').value != 0 && this.formNewClient.get('taxRate').value) return;
        if (ev && (type == 'numberBills' || type == 'rules')) {
            this.obj_checkQuantityText[type] = ev.length
            return;
        }
        // if (ev && type == "total") ev = this.convert(ev);
        result = this.PATTERNS.PATTERN_001.test(ev)

        if (ev && (type == "price" || type == "total" || type == "priceText" || type == "moneyOrder" || type == "transferMoney" || type == "other")) {
            result = this.PATTERNS.PATTERN_004.test(ev)
        }
        if (!result) {
            this.obj_checkQuantityText[type] = 1000;
            return;
        }
        if (ev || ev == 0) {
            this.obj_checkQuantityText[type] = ev.toString().length
            return;
        }
        if (!ev && type == "total" && (this.formNewClient.get('taxRate').value == "" || this.formNewClient.get('taxRate').value == 0 || !this.formNewClient.get('taxRate').value)) {
            this.obj_checkQuantityText['total'] = 0;
            return;
        }
        if (!ev && type == "total" && (this.formNewClient.get('taxRate').value != "" || this.formNewClient.get('taxRate').value != 0 || this.formNewClient.get('taxRate').value)) {
            this.obj_checkQuantityText['total'] = 0;
            return;
        }
        this.obj_checkQuantityText[type] = 0;
    }

    //can't enter key e in input
    checkKeyE(ev: KeyboardEvent, type: any) {
        if (ev.key === 'e' || ev.key === '+' || ev.key == '-' || ev.key == '.' || ev.key == ',') {
            ev.preventDefault();
            return;
        }
    }

    onpaste(ev: any, type: any) {
        let clipboardData = ev.clipboardData;
        let pastedText = clipboardData.getData('text').split('');
        let check = pastedText.find(element => {return (element == 'e' || element == '+' || element == '-' || element == '.' || element == ',')});
        if (check) {
            ev.preventDefault();
            return;
        }
    }

    printHtml(content, fileName) {
        var iframe = document.createElement('iframe')
        document.body.classList.add('print-mode')
        iframe.classList.add('print-zone')        

        document.body.appendChild(iframe)
        var iframedoc = iframe.contentDocument || iframe.contentWindow.document
        iframedoc.body.innerHTML = content

        document.title = fileName;
        setTimeout(() => {
            document.title = fileName;
            iframe.contentWindow.print()
            iframe.contentWindow.close()
            document.title = "Orthocomm";
        }, 500)
    }

    formaMoney(value: any){
        let formatter = new Intl.NumberFormat('ja-JP', {
            style: 'currency',
            currency: 'JPY',
        });
        return formatter.format(value)
    }

    formatNumber(ev: any,type: any){
        if(!ev) return;
        let numberCv = this.subText((ev.target.value).toString());
        this.formNewClient.controls[type].setValue(numberCv)
    }

    //cut text if number start 0 exp: 00000001 -> subtext = 1
    subText(value: any){
        value = value.toString();
        let text = '';
        if(Number(value) == 0){
            text = ''
            return text;
        }
        let arrText = value.split('');
        for (let i = 0; i < arrText.length; i++) {
            if(arrText[i] != 0){
                arrText.splice(0,i)
                break;
            }
        }
        arrText.forEach(element => {
            text = text + element
        });
        return text;
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/client-detail/receipt/receipt.component.ts